import TemperaryRequestList from './List'
import TemperaryRequestEdit from './Edit'

const temperaryRequestResource = {
  list: TemperaryRequestList,
  edit: TemperaryRequestEdit,
}

export default temperaryRequestResource
